<template>
  <div
    class="login-wrap"
    :class="{
      'is-mobile': isMobile,
      'is-dialog': isDialog,
      'zlzp-footer': hasCustomLoginPage,
      'is-pc': !isMobile,
      [`${layoutId}-layout`]: true,
    }"
    :style="backgroundStyle"
  >
    <slot name="container"></slot>
    <LoginFooter v-if="hasCustomLoginPage" :logoColor="hasCustomLoginPage" />
  </div>
</template>

<script>
import { getBusinessType } from '@/constant'
import { getItem } from '@/utils/storage-main'
import LoginFooter from '@/components/login/LoginFooter.vue'
export default {
  name: '',
  data() {
    return {}
  },

  components: { LoginFooter },

  computed: {
    backgroundStyle() {
      return {
        backgroundImage: this.isMobile
          ? getItem('business')
            ? `url(${getBusinessType().bg})`
            : 'auto'
          : getItem('business')
          ? `url(${getBusinessType().pcBg})`
          : 'auto',
        minHeight: this.minHeight(),
        backgroundSize: 'cover',
        backgroundRepeat: `${getBusinessType().bgRepeat || 'round'}`,
      }
    },
    isDialog() {
      return this.$store.state.isDialog || false
    },
    hasCustomLoginPage() {
      return (
        getBusinessType().hasCustomLoginPage &&
        !this.isMobile &&
        getBusinessType().id === 'zlzp'
      )
    },
    layoutId() {
      return getBusinessType().id
    },
  },

  beforeMount() {},

  mounted() {},

  methods: {
    minHeight() {
      if (this.isMobile) return 'auto'

      const routerName = this.$route.name.toLowerCase()
      if (['newlogin', 'personalinfo'].indexOf(routerName) !== -1) {
        // 登录 & 补充信息页
        return '570px'
      } else if (routerName === 'register') {
        if (this.$route.params.step === 'account') {
          // 注册首页
          return '570px'
        } else if (!this.$route.query.event_id) {
          // 平台注册非首页
          return '640px'
        }
      }

      return '770px'
    },
  },
}
</script>
<style lang="scss" scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 770px;
  &.is-mobile {
    overflow-y: auto;
    // min-height: auto;
    height: 100vh;
  }
  &.is-dialog {
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(24px);
  }
  &.zlzp-footer {
    display: flex;
    .login-footer {
      padding-bottom: 32px;
    }
  }
}
</style>
